import { environment } from '../../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('ClientContactService', ClientContactService);

  ClientContactService.$inject = [
    'RestResource',
    '$translate',
    '$filter',
    'UtilService',
    'ClientContactModalService',
  ];

  function ClientContactService(
    RestResource,
    $translate,
    $filter,
    UtilService,
    ClientContactModalService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'clients';

    var service = {
      getClientContacts: getClientContacts,
      openClientContactModal: openClientContactModal,
      saveClientContact: saveClientContact,
      changeClientContactStatus: changeClientContactStatus,
      changeClientContactDefault: changeClientContactDefault,
      deleteClientContact: deleteClientContact,
    };

    return service;

    ////////////////

    function getClientContacts(clientId, filterCriteria) {
      var url = apiUrl + '/' + clientId + '/client_contacts';
      return RestResource.request(
        'get',
        url,
        filterCriteria,
        function (response) {
          return response.data;
        },
        {}
      );
    }

    function openClientContactModal(clientContact, client, mode, fast, successCallback) {
      var originalItem = angular.copy(clientContact);

      var confirmCallback = function (response) {
        if (clientContact.id) {
          // Edit
          //clientContact = response; // not updating

          clientContact.name = response.name;
          clientContact.last_name = response.last_name;
          clientContact.position = response.position;
          clientContact.email = response.email;
          clientContact.phone_number = response.phone_number;
          clientContact.phone_extension = response.phone_extension;
          clientContact.mobile_number = response.mobile_number;

          utils.itemListChanged(response.id);
        }

        return successCallback(response);
      };

      ClientContactModalService.openClientContact(
        originalItem,
        client,
        mode,
        fast,
        confirmCallback
      );
    }

    function saveClientContact(clientContact, clientId) {
      var itemAddedMsg = $translate('CONTACT_ADDED');
      var itemModifiedMsg = $translate('CONTACT_MODIFIED');

      var url = apiUrl + '/' + clientId + '/client_contacts';

      var method = clientContact.id ? 'put' : 'post';
      url = clientContact.id ? url + '/' + clientContact.id : url;

      function success(response) {
        var msg = clientContact.id ? itemModifiedMsg : itemAddedMsg;
        utils._successMsg(msg);

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(method, url, { client_contact: clientContact }, success, failure);
    }

    function changeClientContactStatus(clientContact, clientId) {
      var url = apiUrl + '/' + clientId + '/client_contacts/' + clientContact.id;

      var params = { title: null, successMsg: null };
      if (clientContact.status === 'active') {
        params.title = 'DEACTIVATE_CONTACT';
        params.successMsg = 'CONTACT_MODIFIED';
      }

      utils.changeItemStatus(url, clientContact, params);
    }

    function changeClientContactDefault(clientContact, successCallback) {
      var url = apiUrl + '/' + clientContact.client_id + '/client_contacts/' + clientContact.id;

      var params = {
        client_contact: {
          is_default: true,
        },
        set_default: true,
      };

      function success() {
        var msg = $translate('DEFAULT_CONTACT_CHANGED');
        utils._successMsg(msg);

        return successCallback();
      }
      function failure() {}

      return RestResource.request('put', url, params, success, failure);
    }

    function deleteClientContact(clientContact, clientId, successCallback, index) {
      var params = {
        title: 'DELETE_CONTACT',
        reason: 'DELETE_ITEM_REASON',
        successMsg: 'CONTACT_DELETED',
      };

      var url = apiUrl + '/' + clientId + '/client_contacts/' + clientContact.id;
      utils.deleteItem(url, successCallback, params, index);
    }
  }
})();
